export const environment = {
    production: true,
    config: {
        domain: "app.zendy.tel",
        environment: "production-zendy",
        pageSize: 100,
        paginationSize: 5,
        paypal: {
            clientId: 'ASUCA_Fx8qP4SC_UENGDf-G5_eQ26RnWVoJC-TBklYekGvrRqPaiQdyCk9qFbnHVstmHXNQf5Y0Kg7do'
        },
        bbva: {
            notification_url_api: 'https://api.zendy.tel/tpv/notificate',
            tpv_redirect_url: 'https://sis.redsys.es/sis/realizarPago',
            currency_code: "978",
            merchant_code: "361362585",
            notification_url_ok: "https://app.zendy.tel/recharges/checkout/ok",
            notification_url_ko: "https://app.zendy.tel/recharges/checkout/ko",
            transaction_type: "0",
            merchant_terminal_id: "001",
            description: "Recarga app.zendy.tel"
        },
        termsAndConditionsVersion: "1",
        transfersUrl: 'https://transfers.zendy.tel',
        transfersAccountURL: 'https://transfers.zendy.tel/account',
      creditsUrl: 'https://zendy.lendismart.com/api/public/application-template/483cc45c-5344-404b-9c9e-5f9cd5c6aac5',
        //mobileUrl: 'https://movil.zendy.tel/indexMovil.php',
        mobileUrl: 'https://zendytarifas.es/#mobile',
    }
};
